module.exports = __webpack_public_path__ + "assets/img/8e6385348c6ff5789b52b3ae1e56cebe.png";